<template>
  <div v-if="post" style="font-family: Dosis, Helvetica, Arial, sans-serif; font-size: 20px;">
    <el-row v-if="post.photos && post.photos.length > 1">
      <el-col :lg="18">
        <el-image v-if="post.photoPrincipale != null"
                  style="width: 550px; height: 350px"
                  :src="post.photoPrincipale.url" fit="cover">
        </el-image>
      </el-col>
      <el-col :lg="6">
        <el-row>
          <el-col :lg="24">
            <el-image v-if="post.photos[1] != null"
                      :src="post.photos[1].url" fit="cover" style="height: 111px">
            </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24">
            <el-image v-if="post.photos[2] != null"
                      :src="post.photos[2].url" fit="cover" style="height: 111px">
            </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24">
            <el-image v-if="post.photos[3] != null"
                      :src="post.photos[3].url" fit="cover" style="height: 111px">
            </el-image>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :lg="24">
        <el-image v-if="post.photoPrincipale != null"
                  style="width: 730px; height: 350px"
                  :src="post.photoPrincipale.url" fit="cover">
        </el-image>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 15px;">
      <div v-if="post.prixDisplay || post.honoraire_charge_acquereur || this.prixDisplay">
        <div class="grid-content bg-purple text-center" id="blockPrix">
          <div v-if="this.prixDisplay">
            <strong>{{ $t('posts.view.saleConditionsPrice') }} : {{ this.prixDisplay }}</strong>
          </div>
          <div v-else>
            <strong>{{ $t('posts.view.saleConditionsPrice') }} : {{ post.prixDisplay }}</strong><br>
            <div v-if="post.prix_terrain">{{ $t('posts.view.saleConditionsLand') }} : {{ post.prix_terrain }}
              {{ post.devise_iso_4217 }}
            </div>
            <div v-if="post.honoraire_charge_acquereur">{{ $t('posts.view.saleConditionsBuyerFee') }} :
              {{ post.honoraire_charge_acquereur }}
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row>
      <ul style="padding-left: 50px;">
        <el-col :lg="8">
          <li v-if="post.surface_min">{{ $labels.surface_min }} : {{ post.surface_min }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.surface_max">{{ $labels.surface_max }} : {{ post.surface_max }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.surface_utile">{{ $labels.surface_utile }} : {{ post.surface_utile }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.surface_habitable">{{ $labels.surface_habitable }} : {{ post.surface_habitable }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.surface_sejour">{{ $labels.surface_sejour }} : {{ post.surface_sejour }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.avec_jardin">{{ $labels.avec_jardin }} : {{ displayBoolean(post.avec_jardin) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nb_garages">{{ $labels.nb_garages }} : {{ post.nb_garages }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nb_pieces_logement">{{ $labels.nb_pieces_logement }} : {{ post.nb_pieces_logement }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nombre_de_chambres">{{ $labels.nombre_de_chambres }} : {{ post.nombre_de_chambres }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nb_salles_de_bain">{{ $labels.nb_salles_de_bain }} : {{ post.nb_salles_de_bain }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.balcon">{{ $labels.balcon }} : {{ displayBoolean(post.balcon) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.terrasse">{{ $labels.terrasse }} : {{ displayBoolean(post.terrasse) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.cave">{{ $labels.cave }} : {{ displayBoolean(post.cave) }}</li>
        </el-col>
      </ul>

    </el-row>

    <el-row>

      <el-col :lg="13" style="border: solid;
        border-color: #00b4cc;
        border-width: 1px;
        margin-top: 20px;
        margin-right: 5px;
        overflow: hidden;
        text-align: center">
        <strong>{{ titreVitrine }}</strong>
        <p style="font-size: 16px;text-align: justify;margin-top: 15px;
        margin: 15px;text-size-adjust: auto;">{{ truncateText(post.texte) }}</p>
        <div>

          </p>
        </div>
        <div v-if="post.exposition || post.environnement || post.belle_vue || post.standing ||
                        post.vue_sur_mer || post.est_calme || post.avec_vis_a_vis || post.proche_bus ||
                        post.proche_tram || post.proche_metro || post.proche_gare || post.proche_commerces ||
                        post.ecoles_a_proximitees || post.proche_creche || post.espaces_verts">
          <strong>{{ $t('posts.environmentTitle') }}</strong>
          <p style="font-size: 16px;text-align: justify;margin-top: 15px;
        margin: 15px;">
            <el-row :gutter="20">
              <el-col>
                {{ environnementString }}
              </el-col>
            </el-row>
          </p>
        </div>
        <div :style="fontStyleRef">
          <strong>{{ $t('posts.view.referenceAnnonce') }} : {{ post.reference }}</strong>
        </div>
      </el-col>
      <el-col :lg="10" style="margin-top: 20px;">
        <el-row>
          <el-col :lg="24" style="border: solid;
                                  text-align: -webkit-center;
                                  border-color: #00b4cc;
                                  border-width: 1px;
                                  padding-bottom: 20px;
                                  height: 215px;
                                  " v-if="post.dpe_etiquette_conso && post.dpe_etiquette_ges && post.annonceParente">
            <EtiquetteDPEGESPdfNew :post="post"></EtiquetteDPEGESPdfNew>
          </el-col>
          <el-col v-else style="border: solid;
                                  text-align: left;
                                  border-color: #00b4cc;
                                  border-width: 1px;
                                  font-size: 16px
                                  ">
            <div v-if="post.prix_min">
              <strong>{{ $labels.prix_min }}</strong> : {{ post.prix_min }} {{ post.devise_iso_4217 }}<br>
            </div>
            <div v-if="post.prix_max">
              <strong>{{ $labels.prix_max }}</strong> : {{ post.prix_max }} {{ post.devise_iso_4217 }}<br>
            </div>
            <div style="padding-top: 15px;" v-if="post.defisc_loi_pinel || post.defisc_loi_duflot || post.defisc_loi_censi_bouvard || post.defisc_loi_girardin_paul || post.defisc_loi_malraux || post.defisc_loi_demessine
        || post.defisc_regime_scpi || post.defisc_nue_propriete_demembrement || post.pret_locatif_social || post.compatible_psla || post.defisc_loi_mh || post.compatible_ptz_plus || post.defisc_tva_5_virgule_5_pourcent
        || post.defisc_tva_7_pourcent || post.accession_maitrisee || post.accession_libre || post.bail_reel_solidaire || post.habitat_participatif || post.organisme_foncier_solidaire || post.taux_tva">

              <strong>{{ $t('posts.labelsAndCertificationsTitle') }}</strong>
              <ul style="margin-left: 35px">
                <li v-if="post.defisc_loi_pinel">{{ $labels.defisc_loi_pinel }}
                </li>
                <li v-if="post.defisc_loi_duflot">{{ $labels.defisc_loi_duflot }}
                </li>
                <li v-if="post.defisc_loi_censi_bouvard">{{ $labels.defisc_loi_censi_bouvard }}</li>
                <li v-if="post.defisc_statut_lmp">{{ $labels.defisc_statut_lmp }}</li>
                <li v-if="post.defisc_statut_lmnp">{{ $labels.defisc_statut_lmnp }}</li>
                <li v-if="post.defisc_loi_girardin_paul">{{ $labels.defisc_loi_girardin_paul }}</li>
                <li v-if="post.defisc_loi_malraux">{{ $labels.defisc_loi_malraux }}</li>
                <li v-if="post.defisc_loi_demessine">{{ $labels.defisc_loi_demessine }}</li>
                <li v-if="post.defisc_regime_scpi">{{ $labels.defisc_regime_scpi }}</li>
                <li v-if="post.defisc_nue_propriete_demembrement">{{ $labels.defisc_nue_propriete_demembrement }}</li>
                <li v-if="post.pret_locatif_social">{{ $labels.pret_locatif_social }}</li>
                <li v-if="post.compatible_psla">{{ $labels.compatible_psla }}</li>
                <li v-if="post.defisc_loi_mh">{{ $labels.defisc_loi_mh }}</li>
                <li v-if="post.compatible_ptz_plus">{{ $labels.compatible_ptz_plus }}</li>
                <li v-if="post.defisc_tva_5_virgule_5_pourcent">{{ $labels.defisc_tva_5_virgule_5_pourcent }}</li>
                <li v-if="post.defisc_tva_7_pourcent">{{ $labels.defisc_tva_7_pourcent }}</li>
                <li v-if="post.accession_maitrisee">{{ $labels.accession_maitrisee }}</li>
                <li v-if="post.accession_libre">{{ $labels.accession_libre }}</li>
                <li v-if="post.bail_reel_solidaire">{{ $labels.bail_reel_solidaire }}</li>
                <li v-if="post.habitat_participatif">{{ $labels.habitat_participatif }}</li>
                <li v-if="post.organisme_foncier_solidaire">{{ $labels.organisme_foncier_solidaire }}</li>
                <li v-if="post.taux_tva == 5.5">{{ $t('posts.edit.beneficieTVA5') }}</li>
                <li v-if="post.taux_tva == 7">{{ $t('posts.edit.beneficieTVA7') }}</li>
              </ul>
            </div>

          </el-col>
        </el-row>
        <el-row style="margin-top: 4px;">
          <el-col :lg="24"
                  style="border: solid;
                  border-color: #00b4cc;
                  border-width: 1px;padding-top: 10px;">
            <el-row align="middle">
              <el-col :lg="10" align="center">
                <img v-if="sitimmoUser.logoUrl"
                     :src="'data:image/png;base64,' + sitimmoUser.logo" width="100"/>
                <div v-else>&nbsp;</div>
              </el-col>
              <el-col :lg="13">
                <p :style="fontStyleMail">
                  {{sitimmoUser.raisonSociale}}<br>
                  <div v-if="post.contact_a_afficher" :style="fontStyleMail">
                    {{ post.contact_a_afficher }}
                  </div>
                  <div :style="fontStyleMail" v-if="post.adresse_contact_a_afficher && post.code_postal_contact_a_afficher && post.ville_contact_a_afficher">
                    {{post.adresse_contact_a_afficher}} - {{post.code_postal_contact_a_afficher}} {{post.ville_contact_a_afficher}}
                  </div>
                  <div :style="fontStyleMail" v-else>
                    {{sitimmoUser.adresse}} - {{sitimmoUser.codePostal}} {{sitimmoUser.ville}}
                  </div>
                  <div v-if="post.telephone_a_afficher && post.email_a_afficher" :style="fontStyleMail">
                    <strong>Tel. : {{post.telephone_a_afficher}}<br>
                      Mail : {{post.email_a_afficher}}<br></strong>
                  </div>
                  <div v-else :style="fontStyleMail">
                    <strong>Tel. : {{sitimmoUser.telephone}}<br>
                      Mail : {{sitimmoUser.email}}<br></strong>
                  </div>
                </p>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { deviseSimple } from '@/services/toolbox'
import EtiquetteDPEGESPdfNew from '@/pages/posts/forms/Block/EtiquetteDPEGESPdfNew'
import { getTitreAlternatif } from '@/helpers/posts/getTitreAlternatif'

export default {
  name: 'PostPdfImmoPromoteur',
  components: { EtiquetteDPEGESPdfNew },
  props: ['post', 'sitimmoUser', 'universe'],
  data () {
    return {
      prixDisplay: null,
      stylePrix: 'color:#0ab1bf;font-size: 100px;',
      environnementData: [],
      environnementString: '',
      fontStyleMail: 'font-size: 12px;text-size-adjust: auto;',
      fontStyleRef: 'font-size: 12px;text-size-adjust: auto;text-align:right;padding-right:5px'
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    titreVitrine () {
      return getTitreAlternatif(this.post)
    }
  },
  watch: {
    post: function (post) {
      if (post && post.financement_mensualites) {
        this.stylePrix = 'color:#0ab1bf;font-size: 72px;'
      }
      if (post) {
        this.formatEnvironnement()
      }
    }
  },
  methods: {
    truncateText (texte) {
      let suffix = ''
      if (texte.length > 600) {
        suffix = suffix + '...'
      }
      return texte.substring(0, 600) + suffix
    },
    displayBoolean (value) {
      if (value === true) {
        return this.$t('general.yes')
      }
      if (value === false) {
        return this.$t('general.no')
      }
      return value
    },
    fontSizeEmail () {
      if (this.user.email && this.user.email.length >= 22) {
        this.fontStyleMail = 'font-size: 10px;text-size-adjust: auto;'
      }
    },
    convertDevise (devise) {
      return deviseSimple(devise)
    },
    convertText () {
      const text = this.post.equipments + ' ' + this.post.texte
      return text.substring(0, 1000)
    },
    formatEnvironnement () {
      if (!this.post) return

      if (this.post.belle_vue) {
        this.environnementData.push(this.$labels.belle_vue)
      }
      if (this.post.vue_sur_mer) {
        this.environnementData.push(this.$labels.vue_sur_mer)
      }
      if (this.post.est_calme) {
        this.environnementData.push(this.$labels.est_calme)
      }
      if (this.post.avec_vis_a_vis) {
        this.environnementData.push(this.$labels.avec_vis_a_vis)
      }
      if (this.post.proche_bus) {
        this.environnementData.push(this.$labels.proche_bus)
      }
      if (this.post.proche_tram) {
        this.environnementData.push(this.$labels.proche_tram)
      }
      if (this.post.proche_metro) {
        this.environnementData.push(this.$labels.proche_metro)
      }
      if (this.post.proche_gare) {
        this.environnementData.push(this.$labels.proche_gare)
      }
      if (this.post.proche_commerces) {
        this.environnementData.push(this.$labels.proche_commerces)
      }
      if (this.post.ecoles_a_proximitees) {
        this.environnementData.push(this.$labels.ecoles_a_proximitees)
      }
      if (this.post.proche_ecole_primaire) {
        this.environnementData.push(this.$labels.proche_ecole_primaire)
      }
      if (this.post.proche_creche) {
        this.environnementData.push(this.$labels.proche_creche)
      }
      if (this.post.espaces_verts) {
        this.environnementData.push(this.$labels.espaces_verts)
      }

      if (this.environnementData.length > 0) {
        this.environnementString = this.environnementData.join(', ')
        this.environnementString = this.environnementString.toLowerCase()
        this.environnementString = this.environnementString[0].toUpperCase() + this.environnementString.slice(1)
      }
    }
  }
}
</script>

<style>

</style>
